// Mock data for SuperTool AI

export const mockProjects = [
  {
    id: '1',
    name: 'E-commerce Dashboard',
    description: 'A full-stack e-commerce admin dashboard',
    status: 'deployed',
    lastModified: '2024-03-10T10:30:00Z',
    previewUrl: 'https://example.com/preview1',
    technology: ['React', 'FastAPI', 'MongoDB'],
    credits: 45,
    aiModel: 'claude'
  },
  {
    id: '2',
    name: 'Task Manager App',
    description: 'Project management and task tracking',
    status: 'building',
    lastModified: '2024-03-11T14:20:00Z',
    previewUrl: '',
    technology: ['React', 'Node.js', 'PostgreSQL'],
    credits: 28,
    aiModel: 'openai'
  },
  {
    id: '3',
    name: 'AI Chatbot',
    description: 'Customer service chatbot with NLP',
    status: 'testing',
    lastModified: '2024-03-09T09:15:00Z',
    previewUrl: 'https://example.com/preview3',
    technology: ['React', 'Python', 'OpenAI'],
    credits: 67,
    aiModel: 'grok'
  },
  {
    id: '4',
    name: 'Recipe Finder',
    description: 'Image-based recipe recommendation app',
    status: 'draft',
    lastModified: '2024-03-08T16:45:00Z',
    previewUrl: '',
    technology: ['React', 'FastAPI', 'Claude Vision'],
    credits: 12,
    aiModel: 'claude'
  }
];

export const mockChatMessages = [
  {
    id: '1',
    role: 'user',
    content: 'Build me a task management app with drag and drop functionality',
    timestamp: '2024-03-11T14:20:00Z'
  },
  {
    id: '2',
    role: 'assistant',
    content: 'I\'ll help you build a task management app with drag-and-drop! Let me break this down into phases:\n\n**Phase 1: Frontend Design**\n- Modern card-based layout\n- Drag-and-drop columns (To Do, In Progress, Done)\n- Smooth animations\n\n**Phase 2: Backend**\n- Task CRUD APIs\n- User authentication\n- Real-time updates\n\n**Phase 3: Testing & Deployment**\n- Automated testing\n- Deploy to production\n\nStarting with frontend now...',
    timestamp: '2024-03-11T14:20:30Z',
    agentStatus: 'building',
    progress: 45
  },
  {
    id: '3',
    role: 'system',
    content: 'Frontend agent completed. Created 12 components. Running tests...',
    timestamp: '2024-03-11T14:22:00Z',
    agentType: 'frontend'
  },
  {
    id: '4',
    role: 'assistant',
    content: 'Great progress! Frontend is looking amazing. The drag-and-drop is working smoothly. Would you like me to proceed with backend implementation?',
    timestamp: '2024-03-11T14:23:00Z',
    agentStatus: 'awaiting_input'
  }
];

export const mockAgents = [
  {
    id: 'e1-agent',
    name: 'E1 Agent',
    status: 'idle',
    description: 'Full-stack coding agent',
    avatar: 'E1'
  },
  {
    id: 'frontend-agent',
    name: 'Frontend',
    status: 'idle',
    description: 'React, Tailwind, UI/UX',
    avatar: 'FE'
  },
  {
    id: 'backend-agent',
    name: 'Backend',
    status: 'idle',
    description: 'FastAPI, MongoDB, APIs',
    avatar: 'BE'
  },
  {
    id: 'testing-agent',
    name: 'Testing',
    status: 'idle',
    description: 'pytest, Playwright, QA',
    avatar: 'QA'
  },
  {
    id: 'deploy-agent',
    name: 'Deploy',
    status: 'idle',
    description: 'Vercel, Railway, CI/CD',
    avatar: 'CD'
  }
];

export const mockUserProfile = {
  id: 'user-1',
  name: 'John Developer',
  email: 'john@example.com',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=John',
  credits: 150,
  plan: 'Pro',
  projectsCount: 12,
  joinedDate: '2024-01-15T00:00:00Z'
};

export const mockActivityLog = [
  {
    id: '1',
    type: 'deploy',
    message: 'E-commerce Dashboard deployed successfully',
    timestamp: '2024-03-10T10:30:00Z',
    projectId: '1'
  },
  {
    id: '2',
    type: 'build',
    message: 'Started building Task Manager App',
    timestamp: '2024-03-11T14:20:00Z',
    projectId: '2'
  },
  {
    id: '3',
    type: 'test',
    message: 'AI Chatbot passed all tests',
    timestamp: '2024-03-09T09:45:00Z',
    projectId: '3'
  }
];
